import Api from './api'

export default {
  namespaced: true,
  state: {
    studies: [],
    token: '',
    counts: {}
  },
  getters: {
    studyUUIDs: (state) => {
      return state.studies.map(item => item.file_uuid)
    },
    shouldCompareBtnShow: (state, getters, rootState, rootGetters) => {
      let count = 0

      state.studies.forEach(study => {
        count += state.counts[study.id_file] || 0
      })
      return count >= 2 && !rootGetters['config/restrictProViewer']
    },
    studies: state => state.studies
  },
  mutations: {
    setStudies (state, studies) {
      state.studies = studies
    },
    setStudyCount (state, { idFile, count }) {
      state.counts = { ...state.counts, [idFile]: count }
    },
    setToken (state, token) {
      state.token = token
    },
    clear (state) {
      state.studies = []
      state.token = ''
      state.counts = {}
    }
  },
  actions: {
    async loadStudyCounts ({ commit, state, dispatch }, studies) {
      await Promise.all(
        studies
          .filter(study => state.counts[study.id_file] === undefined)
          .map(async study => {
            let count = 0
            try {
              const { data } = await Api.getV2(`file/${study.id_file}/contains-dicom-study`, {
                params: { type: 'vault' }
              })
              count = data.count
            } catch (e) {
              console.error(e)
              dispatch('feedback/addSnack', { text: this._vm.$tf('No studies to compare') }, { root: true })
            }
            commit('setStudyCount', { idFile: study.id_file, count })
          })
      )
    },
    async getJWT ({ commit }, studyUUIDs) {
      try {
        const { data } = await Api.postV2('remote/sign/files', {
          data: studyUUIDs
        })

        commit('setToken', data.signed)

        return data
      } catch (error) {
        throw Error(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/compare.js